import { CardVariant } from '@Page/SalaryTaxCard/component/StatusBar/StatusBar';
import { Icon, Spinner } from '@tlx/atlas';
import classNames from 'classnames';

export type StatusIconProps = {
    color: string;
    bg: string;
    icon: string | CardVariant;
};

export function StatusIcon({ color, bg, icon }: StatusIconProps) {
    return (
        <div className="taxcard-status__icons-container">
            {icon == CardVariant.Spinner ? (
                <div className="atl-ml-16 atl-mr-16 atl-my-8">
                    <Spinner size="small" />
                </div>
            ) : (
                <div className={classNames('taxcard-status__icon', bg)}>
                    <Icon className={classNames(color)}>{icon.toString()}</Icon>
                </div>
            )}
        </div>
    );
}
